import * as actionTypes from "../actionTypes";

export const getCareersRequest = (payload) => ({
    type: actionTypes.GET_CAREERS_REQUEST,
    payload,
});

export const getCareersSuccess = (payload) => ({
    type: actionTypes.GET_CAREERS_SUCCESS,
    payload,
});

export const getCareersError = (error) => ({
    type: actionTypes.GET_CAREERS_ERROR,
    payload: error,
});

export const setCareersRequest = (payload) => ({
    type: actionTypes.SET_CAREERS_REQUEST,
    payload,
});

export const setCareersSuccess = (payload) => ({
    type: actionTypes.SET_CAREERS_SUCCESS,
    payload,
});

export const setCareersError = (error) => ({
    type: actionTypes.SET_CAREERS_ERROR,
    payload: error,
});